var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',{staticClass:"expansion-panel",attrs:{"value":_vm.value},on:{"input":_vm.onInput}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }